import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

// La búsqueda de dirección por Google (CompanyBillingAddressSearch) se eliminó del flujo.
// Esta ruta se mantiene registrada por compatibilidad (links/bookmarks viejos), pero ya no
// debe mostrar contenido propio: siempre redirige al formulario de edición sin mapa.
const CompanyBillingAddressEditContainer = () => {
  const location = useLocation<unknown>();

  return <Redirect to={{ pathname: '/corporate/companyBillingMapEdit', state: location.state }} />;
};

export default CompanyBillingAddressEditContainer;
